import type { UseQueryResult } from "@tanstack/react-query";

import { apiClient } from "app/modules/api-client";
import type { ICitationsOverview } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/types";
import { useLLMReportQuery } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/hooks/useLLMReportQuery";
import type { ILLMWidgetRequestParams } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

export const useCitationsOverview = (
    params: ILLMWidgetRequestParams,
    options?: { enabled?: boolean },
): UseQueryResult<ICitationsOverview> =>
    useLLMReportQuery<ICitationsOverview, ILLMWidgetRequestParams>(
        "citationsOverview",
        apiClient.AiTracker.aiTrackerReportsSourceAnalysisReportOverviewList,
        params,
        options,
    );
